module.exports = __webpack_public_path__ + "img/5H.93cafc8d.png";